import { useHttp } from '@d5/hooks'
import { ID5MetaType } from '@d5/ui'

import { ILoginType, ILoginResponseType } from '@/pages/Login/types'

export const useLogin = (data: ILoginType) =>
  useHttp<ILoginResponseType>({
    url: '/users/sessions',
    method: 'post',
    data,
  })

export const usePermissions = (user_id: number | string) =>
  useHttp<{ meta: ID5MetaType; data: { permissions: Array<string> } }>({
    url: `/users/${user_id}/permissions`,
  })
